
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import CitySkylineSvg from '@/components/hero/CitySkylineSvg';
import AnimatedRouteMap from '@/components/hero/AnimatedRouteMap';

const scrollToBooking = () => {
  document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
};

const Hero = () => {
  const isMobile = useIsMobile();

  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-ride-primary to-ride-secondary text-white">
      <div
        className={`relative z-10 ${isMobile ? 'px-4 py-12' : 'container mx-auto px-4 py-16 md:py-24'}`}
      >
        <div
          className={
            isMobile
              ? 'flex flex-col items-center gap-8 text-center'
              : 'grid grid-cols-1 items-center gap-12 md:grid-cols-2'
          }
        >
          <div className={isMobile ? 'w-full' : 'max-w-xl'}>
            <h1
              className={`${isMobile ? 'text-3xl' : 'text-4xl md:text-5xl lg:text-6xl'} mb-6 font-display font-bold leading-tight`}
            >
              Your ride, your way, anytime
            </h1>
            <p className={`${isMobile ? 'text-base' : 'text-lg md:text-xl'} mb-8 opacity-90`}>
              Fast, reliable rides at your fingertips. Choose your ride type, track your driver,
              and arrive safely at your destination.
            </p>
            {/* Two ways in. Booking is the product; the demo is the only one of
                the two a signed-out visitor can finish, so it sits right next
                to it rather than behind the sign-in page. */}
            <div className={`flex gap-3 ${isMobile ? 'flex-col' : 'flex-col sm:flex-row'}`}>
              <Button
                size="lg"
                onClick={scrollToBooking}
                className="bg-white text-ride-primary shadow-lg hover:bg-white/90"
              >
                Try booking a ride →
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-white/70 bg-transparent text-white hover:bg-white/10 hover:text-white"
              >
                <Link to="/demo">Try the demo — no signup</Link>
              </Button>
            </div>
          </div>

          <div className={isMobile ? 'w-full max-w-sm' : 'w-full'}>
            <AnimatedRouteMap />
          </div>
        </div>
      </div>

      {/* City silhouette */}
      <CitySkylineSvg className="absolute bottom-0 left-0 h-24 w-full opacity-20" />
    </div>
  );
};

export default Hero;
